import exclusive_42b649 from "./exclusive_green.png";
import exclusive_50c3c7 from "./exclusive_blue.png";
import exclusive_f0402a from "./exclusive_red.png";

export default {
  exclusive_42b649,
  exclusive_50c3c7,
  exclusive_f0402a
};



// WEBPACK FOOTER //
// ./src/pages/beers/images/index.js